import { motion } from "framer-motion";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react";
import { track } from "@vercel/analytics";
import * as styles from "./Nav.module.css";

export default function Nav(props) {
  return (
    <motion.nav
      className={styles.wrapper}
      initial={{ opacity: 0, y: -30 }}
      whileInView={{
        opacity: 1,
        y: 0,
        transition: { delay: 0.3, duration: 0.7 },
      }}
      viewport={{ once: true, amount: 0.5 }}
    >
      <section className={styles.logoContainer}>
        {props.logo.map((logo, index) => {
          const image = getImage(logo.image.asset);
          return (
            <motion.a
              href={logo.href}
              aria-label={logo.alt}
              initial={{ opacity: 0, y: -10 }}
              whileInView={{
                opacity: 1,
                y: 0,
                transition: { duration: 0.6, delay: 0.2 * index },
              }}
              viewport={{ once: true, amount: 0.5 }}
              key={index}
            >
              {image && (
                <GatsbyImage
                  className={styles.logo}
                  image={image}
                  alt={logo.alt}
                />
              )}
            </motion.a>
          );
        })}
      </section>
      <section className={styles.navigation}>
        {props.navItems.map((navitem, index) => (
          <motion.span
            initial={{ opacity: 0, y: -10 }}
            whileInView={{
              opacity: 1,
              y: 0,
              transition: { duration: 0.6, delay: 0.2 * index },
            }}
            viewport={{ once: true, amount: 0.5 }}
            className="inline-block"
            key={index}
            aria-label={navitem.name}
          >
            {navitem.link.substring(0, 1) === "/" ? (
              <Link to={navitem.link} aria-label={navitem.name}>
                <p className={styles.navitem} aria-label={navitem.name}>
                  {navitem.name}
                </p>
              </Link>
            ) : (
              <a
                href={navitem.link}
                target="_blank"
                rel="noreferrer"
                aria-label={navitem.name}
                onClick={() =>
                  track("outbound_click", {
                    source: "nav",
                    label: navitem.name ?? "unknown",
                    link: navitem.link,
                  })
                }
              >
                <p className={styles.navitem} aria-label={navitem.name}>
                  {navitem.name}
                </p>
              </a>
            )}
          </motion.span>
        ))}
      </section>
    </motion.nav>
  );
}
